import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "کاربران معرفی شده")
  ])
], -1)
const _hoisted_3 = { class: "card-body card-scroll mh-400px pt-3" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-4 mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom border-gray-200 text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "کاربر"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "معرف"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "ثبت نام"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "زیر مجموعه"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "کل پورسانت"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "مجموع پرداخت"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "موجودی کیف پول")
  ])
], -1)
const _hoisted_8 = { class: "fw-bold text-gray-800" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_11 = { class: "mb-1 fs-7" }
const _hoisted_12 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success fs-7 fw-bold"
}
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_16 = { class: "mb-1 fs-7" }
const _hoisted_17 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-success fs-7 fw-bold"
}
const _hoisted_19 = { class: "badge badge-light-info" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fs-10" }, "نفر", -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "fs-10 text-muted me-1" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "fs-10 text-muted me-1" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "fs-10 text-muted me-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Date = _resolveComponent("Date")!
  const _component_Currency = _resolveComponent("Currency")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_UserCooperationDetails = _resolveComponent("UserCooperationDetails")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (user, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_UserAvatar, {
                          avatar: user.picture,
                          size: "40px",
                          id: user.id
                        }, null, 8, ["avatar", "id"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1),
                          _createElementVNode("span", _hoisted_12, [
                            _createTextVNode(_toDisplayString(user.mobile) + " ", 1),
                            (user.type === `admin`)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getType(user.type)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      (user.representative)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_UserAvatar, {
                              avatar: user.representative.picture,
                              size: "40px",
                              id: user.representative.id
                            }, null, 8, ["avatar", "id"]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(user.representative.first_name) + " " + _toDisplayString(user.representative.last_name), 1),
                              _createElementVNode("span", _hoisted_17, [
                                _createTextVNode(_toDisplayString(user.representative.mobile) + " ", 1),
                                (user.representative.type === `admin`)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getType(user.representative.type)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_Date, {
                        date: user.formatted_created_at
                      }, null, 8, ["date"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_19, [
                        _createTextVNode(_toDisplayString(user.subusers_count) + " ", 1),
                        _hoisted_20
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createTextVNode(_toDisplayString(Number(user.total_commissions).toLocaleString()) + " ", 1),
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_Currency)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createTextVNode(_toDisplayString(Number(user.total_commissions_paid).toLocaleString()) + " ", 1),
                      _createElementVNode("span", _hoisted_24, [
                        _createVNode(_component_Currency)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createTextVNode(_toDisplayString(Number(user.credit).toLocaleString()) + " ", 1),
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_Currency)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_ctx.list && _ctx.list.length === 0)
            ? (_openBlock(), _createBlock(_component_Notice, {
                key: 0,
                classes: "rounded-3",
                color: "primary",
                title: "توجه کنید !",
                body: "لیست خالی می‌باشد."
              }))
            : _createCommentVNode("", true),
          (_ctx.pagination && _ctx.pagination.total_pages > 1)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 1,
                background: "",
                layout: "prev, pager, next",
                class: "mt-4 mb-4 text-center direction-rtl",
                total: _ctx.pagination.total,
                currentPage: _ctx.pagination.current_page,
                "page-size": _ctx.pagination.per_page,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange"]))
            : _createCommentVNode("", true)
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_UserCooperationDetails)
  ], 64))
}